/**
 * Download Button Component
 */

import { DownloadIcon } from 'lucide-preact';

interface DownloadButtonProps {
  className?: string;
}

export function DownloadButton(_: DownloadButtonProps) {

  const getDownloadUrl = () => {
    const platform = navigator.platform.toLowerCase();
    if (platform.includes('mac')) {
      return 'https://github.com/lukejacksonn/nitros/releases/latest/download/nitros-macos.zip';
    } else if (platform.includes('win')) {
      return 'https://github.com/lukejacksonn/nitros/releases/latest/download/nitros-windows.zip';
    } else {
      return 'https://github.com/lukejacksonn/nitros/releases/latest/download/nitros-linux.zip';
    }
  };

  const getOsName = () => {
    const platform = navigator.platform.toLowerCase();
    if (platform.includes('mac')) return 'macOS';
    if (platform.includes('win')) return 'Windows';
    return 'Linux';
  };

  const handleDownloadClick = () => {
    window.open(getDownloadUrl(), '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      onClick={handleDownloadClick}
      class={`px-10 py-4 bg-neutral-800 text-white font-semibold rounded-full transition-all duration-200 shadow-lg transform hover:scale-105 row gap-3 aic`}
    >
      <DownloadIcon class="w-6 h-6" />
      Download for {getOsName()}
    </button>
  );
}
